import { TypeKizaiKind } from "99Tools/utils";

export const getFields = (kind: TypeKizaiKind) => {
  switch (kind) {
    case "lte":
      return [
        "ReceiveTime",
        "DataKind",
        "SensorDataNo",
        "SensorInfo",
        "BuildingName",
        "LocationName",
        "SensorId",
        "SensorName",
        "Voltage",
        "MinVoltage",
        "SensorVer",
        "SensorRSSI",
        "DeviceType",
        "M_CYCL",
        "CONF",
        "DeadLine",
        "ValidItem",
      ];
    case "subgiga":
      return [
        "ReceiveTime",
        "DataKind",
        "SensorDataNo",
        "PicoDataNo",
        "SensorInfo",
        "BuildingName",
        "LocationName",
        "SensorId",
        "SensorName",
        "PicoId",
        "Voltage",
        "MinVoltage",
        "SensorVer",
        "SensorRSSI",
        "DeviceType",
        "M_CYCL",
        "DipConf",
        "CONF",
        "ConnectNum",
        "RepeaterID",
        "RepeaterRSSI",
        "DataRoute",
        "DeadLine",
        "ValidItem",
      ];
    case "pico3":
      return [
        "ReceiveTime",
        "DataKind",
        "PicoDataNo",
        "BuildingName",
        "LocationName",
        "PicoId",
        "PicoName",
        "Parent_PicoId",
        "PicoId_repeater",
        "PicoVer",
        "Pico3HWCONF",
        "Pico3TYPE",
        "DestType",
        "PicoRSSI",
        "SSID",
        "M_CYCL",
        "DeadLine",
        "ValidItem",
      ];

    default:
      return [];
  }
};
